import { Configuration } from './types';

export const config: Partial<Configuration> = {
  portalApi: 'https://eca.api.dev.portal.genvis.com/v1',
  remoteHazardAssets: {
    iconAssetsPathSvg: 'https://dev.kudo.genvis.com/assets/icons/map/pins/emo',
    iconAssetsPathPng: 'https://dev.kudo.genvis.com/assets/icons/map/pins/emo/40x40',
  },
  webTemplateStyleSheetUrl: 'https://dev.kudo.genvis.com/assets/styles/ewa-webtemplate.css',
  environment: 'local',
};
